import { Box, Stack, Paper, Divider, Typography } from "@mui/material";
import PaymentDetails from "./PaymentDetails/PaymentDetails";

import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { usePaymentPlans } from "./PaymentPlans/usePaymentPlans";
import { TimeoutCountdownClock } from "../../timeout-worker/TimeoutCountdownClock";
import { useTimeoutWorker } from "../../timeout-worker/useTimeoutWorker";

const Payment = () => {
  const { paymentPlans } = usePaymentPlans();
  const { isTimeoutEnabled } = useTimeoutWorker();

  return (
    <Paper variant="outlined" sx={{ minHeight: "100%" }}>
      <Stack paddingBottom={"24px"}>
        <Stack>
          <Stack
            id="#payment-details-component"
            sx={{ margin: "24px" }}
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography fontWeight={700} fontSize={"24px"}>
              {paymentPlans.length > 0 ? "Checkout" : "Payment"}
            </Typography>
          </Stack>
          <Divider />
        </Stack>
        <Box>
          <PaymentDetails />
        </Box>
      </Stack>
    </Paper>
  );
};

export default Payment;
